fragment GroupPermissionsFragment on GroupPermissions {
  areGroupsInAccessGroupIdsHierarchy
  updateGroupAttributes
}




fragment accessGroupsFragment on Group {
  id
  name
  type
  parentIds
  hierarchy
  hierarchyIds
  attributes {
    id
    attributeType
    subtype
    label
    value
  }
  permissions {
    ...GroupPermissionsFragment
  }
}



fragment PersonFragmentForTaggedMembersPanel on Person {
  aggregateId
  employeeId
  avatar
  company
  fte
  jobTitle
  firstName
  surname
  preferredName
  memberOf {
    id
    parentIds
    name
    type
    hierarchy
    hierarchyIds
    attributes {
      id
      attributeType
      subtype
      label
      value
    }
  }
  tags: appliedTags(filter: $tagFilter) {
    id
    tagId
    type
    displayValue
    isActive
    attributes
    entityTagAttributes
  }
}

fragment PersonFragment on Person {
  address
  country
  city
  aggregateId
  employeeId
  allocations {
    fte
    targetGroupId
  }
  attributes {
    attributeType
    subtype
    value
    id
  }
  avatar
  userAvatarOriginal
  userAvatarCropped
  userAvatarCropData {
    x
    y
    width
    height
  }
  bands
  company
  fte
  jobTitle
  firstName
  surname
  preferredName
  span
  division {
    id
    name
    hierarchy
  }
  managing {
    aggregateId
  }
  memberOf {
    id
    parentIds
    name
    type
    hierarchy
    hierarchyIds
    attributes {
      id
      attributeType
      subtype
      label
      value
    }
    permissions {
      ...GroupPermissionsFragment
    }
    tags {
      id
      type
      displayValue
      isActive
      attributes
    }
  }
  accessGroups {
    ...accessGroupsFragment
  }
  tags: appliedTags {
    id
    tagId
    type
    displayValue
    isActive
    attributes
    entityTagAttributes
  }
  sourceGroupIds
  permissions {
    isInAccessGroupIdsHierarchy
  }
}

fragment PersonBaseFragment on Person {
  address
  country
  city
  aggregateId
  employeeId
  avatar
  bands
  company
  fte
  jobTitle
  firstName
  surname
  preferredName
}

fragment GlobalSearchPersonBaseFragment on Person {
  ...PersonBaseFragment
  allocations {
    fte
    targetGroupId
  }
  attributes {
    attributeType
    subtype
    value
  }
  division {
    id
    name
    hierarchy
  }
  memberOf {
    id
    parentIds
    name
    type
    hierarchy
    hierarchyIds
    attributes {
      id
      attributeType
      subtype
      label
      value
    }
  }
  sourceGroupIds
}


fragment TeamFragment on Group {
  id
  kind
  isHidden
  name
  type
  parentIds
  hierarchyIds
  attributes {
    id
    attributeType
    subtype
    label
    value
  }
}


# Minimal variant for search/display - no tagTypeName, avoids payload bloat
fragment TagMinimalFragment on Tag {
  id
  type
  displayValue
  isActive
  attributes
  appliedCount
  tagAttributesMetaData {
    person {
      aggregateId
      preferredName
      firstName
      surname
      avatar
    }
  }
}

# Use TagFragmentWithAppliedCount instead
fragment TagFragment on Tag {
  id
  type
  displayValue
  isActive
  attributes
  appliedCount
  tagTypeName
  tagAttributesMetaData {
    person {
      aggregateId
      preferredName
      firstName
      surname
      avatar
    }
  }
}

fragment TagFragmentWithAppliedCount on Tag {
  id
  type
  displayValue
  isActive
  attributes
  appliedCount @include(if: $showAppliedCount)
  tagTypeName
  tagAttributesMetaData {
    person {
      aggregateId
      preferredName
      firstName
      surname
      avatar
    }
    people @include(if: $showTagOwners) {
      aggregateId
      preferredName
      firstName
      surname
      avatar
    }
  }
}

fragment TagPropertyFragment on TagProperty {
  id
  label
  value
  attributeType
  subtype
}

# Minimal fragment for allocation/caching - avoids tagAttributesMetaData payload
fragment EntityTagMinimalFragment on EntityTag {
  id
  tagId
  type
  replace
  entityId
  entityTagAttributes
  status
  tag {
    id
    displayValue
    type
    attributes
    isActive
  }
}

fragment EntityTagFragment on EntityTag {
  id
  tagId
  type
  replace
  entityId
  entityTagAttributes
  status
  tag {
    id
    displayValue
    type
    attributes
    appliedCount
    isActive
    tagAttributesMetaData {
      person {
        aggregateId
        preferredName
        firstName
        surname
        avatar
      }
    }
  }
}



query globalSearchQuery(
  $searchTerms: [String]
  $size: Int
  $filter: InsightFilter
  $includePeople: Boolean! = true
  $includeGroups: Boolean! = true
  $includeTags: Boolean! = false
  $personFieldsToSearch: [PersonFieldsToSearch]
  $groupFieldsToSearch: [GroupFieldsToSearch]
  $tagFieldsToSearch: [TagFieldsToSearch]
  $personSearchAfterId: [String]
  $tagsOffset: Int = 0
  $groupsOffset: Int = 0
  $includeEmptyGroups: Boolean = false
) {
  result: globalSearch(
    tagsOffset: $tagsOffset
    groupsOffset: $groupsOffset
    size: $size
    searchTerms: $searchTerms
    filter: $filter
    personFieldsToSearch: $personFieldsToSearch
    groupFieldsToSearch: $groupFieldsToSearch
    tagFieldsToSearch: $tagFieldsToSearch
    personSearchAfterId: $personSearchAfterId
    includeTags: $includeTags
    includePeople: $includePeople
    includeGroups: $includeGroups
    includeEmptyGroups: $includeEmptyGroups
  ) {
    pagedPeople @include(if: $includePeople) {
      totalCount
      searchAfterId
      people {
        ...GlobalSearchPersonBaseFragment
        __typename
      }
      __typename
    }

    pagedGroups @include(if: $includeGroups) {
      totalCount
      groups {
        ...TeamFragment
        __typename
      }
      __typename
    }

    pagedTags @include(if: $includeTags) {
      totalCount
      tags {
        ...TagMinimalFragment
        __typename
      }
      __typename
    }
  }
}
